module.exports = __webpack_public_path__ + "media/Covid-EAS.bc141e96.mp4";